const ValidationModule = {

  setValidationError(error, validationError = {}, fallbackMessage = '') {
    this.clearValidationError(error)
    const errors = validationError && typeof validationError === 'object'
      ? validationError
      : {}
    for (const [key, value] of Object.entries(errors)) {
      error[key] = Array.isArray(value) ? value[0] : value
    }
    Swal.fire({
      title: 'Gagal',
      text: fallbackMessage || (
        Object.keys(errors).length > 0
          ? 'Harap periksa kembali form'
          : 'Terjadi kesalahan pada sistem. Silakan coba kembali.'
      ),
      icon: 'error',
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    })
    return error
  },

  clearValidationError(error) {
    for (const [key] of Object.entries(error)) {
      error[key] = ''
    }
    return error
  },

  clearForm(form) {
    for (const [key] of Object.entries(form)) {
      form[key] = ''
    }
    return form
  }

}

export default ValidationModule
